// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__10Ldu","col":"styles_col__2gV0Q","fulfillmentStatus":"styles_fulfillmentStatus__YGOP6","emailCol":"styles_emailCol__1-nbf"};